import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
  DIAS_CORTOS, capital, diaDelMes, inicioMes, mismoMes, nombreMes, rejillaMes, sumarMeses, textoDiaLargo,
} from '../../lib/calendario';

/**
 * Mes pequeño para saltar de día. `marcados` (Set de «AAAA-MM-DD») pinta un punto; `deshabilitado(ymd)` apaga
 * días (lo usa la página pública de reservas: días sin huecos). `seleccion` puede ser un día o un rango [a, b].
 */
export default function MiniMes({
  valor, hoy, onElegir, marcados, deshabilitado, rango, mesInicial, onCambiarMes, minMes, maxMes, grande = false,
}) {
  const [mes, setMes] = useState(inicioMes(mesInicial || valor || hoy));
  useEffect(() => {
    if (valor && !mismoMes(valor, mes) && !mesInicial) setMes(inicioMes(valor));
  }, [valor]); // eslint-disable-line react-hooks/exhaustive-deps

  const cambiar = (n) => {
    const nuevo = inicioMes(sumarMeses(mes, n));
    setMes(nuevo);
    if (onCambiarMes) onCambiarMes(nuevo);
  };
  const dias = rejillaMes(mes);
  const puedeAtras = !minMes || mes > inicioMes(minMes);
  const puedeAdelante = !maxMes || mes < inicioMes(maxMes);

  return (
    <div className={`cal-minimes ${grande ? 'cal-minimes--grande' : ''}`}>
      <div className="cal-minimes-cab">
        <span className="cal-minimes-titulo">{capital(nombreMes(mes))}</span>
        <button type="button" className="cal-icono-btn" onClick={() => cambiar(-1)} disabled={!puedeAtras} aria-label="Mes anterior">
          <ChevronLeft className="h-4 w-4" />
        </button>
        <button type="button" className="cal-icono-btn" onClick={() => cambiar(1)} disabled={!puedeAdelante} aria-label="Mes siguiente">
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      {/* Sin role="grid": no tiene filas ni celdas y se anunciaba como una tabla rota (K14) */}
      <div className="cal-minimes-rejilla">
        {DIAS_CORTOS.map((d) => <span key={d} className="cal-minimes-dsem">{d}</span>)}
        {dias.map((d) => {
          const fuera = !mismoMes(d, mes);
          const apagado = deshabilitado ? deshabilitado(d) : false;
          const enRango = rango && d >= rango[0] && d <= rango[1];
          const clases = [
            'cal-minimes-dia',
            fuera ? 'is-fuera' : '',
            d === hoy ? 'is-hoy' : '',
            d === valor ? 'is-sel' : '',
            enRango ? 'is-rango' : '',
            apagado ? 'is-apagado' : '',
            marcados && marcados.has(d) ? 'is-marcado' : '',
          ].join(' ');
          return (
            <button
              type="button"
              key={d}
              className={clases}
              disabled={apagado}
              onClick={() => onElegir(d)}
              // «lunes, 5 de octubre · hay horas libres» en vez de «2026-10-05»; los días con hueco no se distinguían más que por color (K14)
              aria-label={`${textoDiaLargo(d)}${marcados && marcados.has(d) ? ' · hay horas libres' : ''}${d === hoy ? ' · hoy' : ''}`}
              aria-pressed={d === valor}
            >
              {diaDelMes(d)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
